import { type ComponentPropsWithRef } from 'react';
import { cn } from '@/lib/utils';
import { MatchesProgress } from '../matches-progress';

type RootProps = ComponentPropsWithRef<'div'>;

const Root = ({ className, ref, ...props }: RootProps) => (
    <div
        data-slot="product-profile-card"
        ref={ref}
        className={cn('w-full flex flex-col gap-2', className)}
        {...props}
    />
);

Root.displayName = 'ProductProfileCard.Root';

type ImageProps = Omit<ComponentPropsWithRef<'img'>, 'alt'> & {
    alt: string;
};

const Image = ({ alt, className, ref, ...props }: ImageProps) => (
    <img
        data-slot="product-profile-card-image"
        ref={ref}
        alt={alt}
        className={cn('w-full aspect-square h-auto object-cover rounded-xs border border-snk-keyline-grey', className)}
        {...props}
    />
);
Image.displayName = 'ProductProfileCard.Image';

type ProgressProps = Omit<ComponentPropsWithRef<'div'>, 'children'> & {
    value: number;
};

const Progress = ({ value, className, ref, ...props }: ProgressProps) => (
    <MatchesProgress.Root
        data-slot="product-profile-card-progress"
        ref={ref}
        className={cn('flex justify-center px-1', className)}
        {...props}>
        <MatchesProgress.Progress value={value} />
        <MatchesProgress.Text>{`${value}%`}</MatchesProgress.Text>
    </MatchesProgress.Root>
);
Progress.displayName = 'ProductProfileCard.Progress';

const ProductProfileCard = { Root, Image, Progress } as const;

export { ProductProfileCard };
